import './Tooltip.scss';

function Tooltip({ icon, text }: { icon: React.JSX.Element, text: string }) {
    return (
        <div className="tooltip-container">
            {icon}
            <div className="tooltip">{text}</div>
        </div>
    )
}

export default Tooltip;